const base = { fill: "none", stroke: "currentColor", strokeWidth: 1.6, strokeLinecap: "square" };

export const CrossIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg viewBox="0 0 24 24" {...base} className={className} aria-hidden="true" {...props}>
    <path d="M12 3v18M6 9h12" />
    <path d="M9.5 3h5M9.5 21h5" strokeWidth="1.1" />
  </svg>
);

export const ShieldCrossIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg viewBox="0 0 24 24" {...base} className={className} aria-hidden="true" {...props}>
    <path d="M12 2.5l8 3.2v6.1c0 4.8-3.4 8.4-8 9.7-4.6-1.3-8-4.9-8-9.7V5.7z" />
    <path d="M12 7.5v8M8.8 10.5h6.4" />
  </svg>
);

export const CrosshairIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg viewBox="0 0 24 24" {...base} className={className} aria-hidden="true" {...props}>
    <circle cx="12" cy="12" r="7.5" />
    <circle cx="12" cy="12" r="3" strokeWidth="1" opacity="0.6" />
    <path d="M12 1.5v3.5M12 19v3.5M1.5 12H5M19 12h3.5" />
    <circle cx="12" cy="12" r="0.6" fill="currentColor" />
  </svg>
);

export const CartridgeIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg viewBox="0 0 24 24" {...base} className={className} aria-hidden="true" {...props}>
    <path d="M10 2.5h4l.8 5.5v10H9.2V8z" />
    <path d="M8 18h8v3H8z" />
    <path d="M10.8 2.5v-1h2.4v1" strokeWidth="1.1" />
  </svg>
);

export const DoveIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg viewBox="0 0 24 24" {...base} className={className} aria-hidden="true" {...props}>
    <path d="M3.5 15.5c2-5.5 6.5-8.5 11-8.5 2.4 0 4.2.8 6-0.5-0.4 2.6-1.8 4.2-3.7 5 1.6.1 3-.1 4.7-1-1.6 2.8-4.8 5-9.5 5z" />
    <path d="M3.5 15.5c-1 .6-1.8 1.6-2.2 3 1.8-.2 3.1-1 4-2.4" strokeWidth="1.1" />
    <circle cx="15.4" cy="8.6" r="0.5" fill="currentColor" stroke="none" />
  </svg>
);

export const IchthysIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg viewBox="0 0 24 24" {...base} className={className} aria-hidden="true" {...props}>
    <path d="M2.5 12C6.5 5.8 14.5 5.8 18.5 12c-4 6.2-12 6.2-16 0z" />
    <path d="M18.5 12l3.5-3.5M18.5 12l3.5 3.5" />
    <circle cx="6.5" cy="11" r="0.5" fill="currentColor" stroke="none" />
  </svg>
);

export const FlameIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg viewBox="0 0 24 24" {...base} className={className} aria-hidden="true" {...props}>
    <path d="M12 2.5c1.8 4.2 5 6.3 5 10.5a5 5 0 11-10 0c0-2 1-3.6 2-4.7.1 1.8.9 2.9 2 3.2-.4-3 .1-6.5 1-9z" />
  </svg>
);

export const SwordIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg viewBox="0 0 24 24" {...base} className={className} aria-hidden="true" {...props}>
    <path d="M12 1.5l1.6 3.2v10.1h-3.2V4.7z" />
    <path d="M7 14.8h10" />
    <path d="M12 14.8v5.2" />
    <circle cx="12" cy="21.2" r="1" />
  </svg>
);

export const ChaliceIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg viewBox="0 0 24 24" {...base} className={className} aria-hidden="true" {...props}>
    <path d="M6.5 3h11c0 4.8-2.4 7.6-5.5 7.6S6.5 7.8 6.5 3z" />
    <path d="M12 10.6V17M8 20.5h8M9.4 17h5.2" />
  </svg>
);
